import { imageSrc } from "./api";

export const EFFECTS = ["snow", "ripples", "petals", "shimmer", "embers", "mist", "flicker", "streaks", "rain", "sway", "parallax", "aura"];
const rand = (a, b) => a + Math.random() * (b - a);

const SPAWN = {
  snow: (W, H) => ({ x: rand(0, W), y: rand(-H, H), s: rand(1.8, 4.4), v: rand(24, 52), ph: rand(0, 6) }),
  petals: (W, H) => ({ x: rand(0, W), y: rand(-H, H), s: rand(5, 10), v: rand(22, 40), ph: rand(0, 6), r: rand(0, 6) }),
  embers: (W, H) => ({ x: rand(0, W), y: rand(H * 0.2, H * 1.4), s: rand(6, 15), v: rand(32, 64), ph: rand(0, 6) }),
  rain: (W, H) => ({ x: rand(0, W * 1.2), y: rand(-H, H), s: rand(10, 20), v: rand(220, 320), ph: 0 }),
  streaks: (W, H) => ({ x: W / 2 + rand(-0.1, 0.1) * W, y: H / 2 + rand(-0.1, 0.1) * H, s: rand(0.12, 0.5) * Math.min(W, H), v: rand(0.25, 0.6), ph: rand(0, 6) }),
};
const COUNT = { snow: 150, petals: 34, embers: 70, rain: 120, streaks: 13 };

function draw(g, fx, list, W, H, t, s, tint, dt) {
  const f = dt * 60 * 0.016;
  if (fx === "snow") {
    g.lineCap = "round";
    list.forEach((p) => {
      p.y += p.v * s * f;
      if (p.y > H) (p.y = -6), (p.x = rand(0, W));
      const x = p.x + Math.sin(t * 0.9 + p.ph) * 8;
      g.strokeStyle = "rgba(40,60,90,0.25)";
      g.lineWidth = 2.6;
      g.beginPath();
      for (let k = 0; k < 3; k++) {
        const a = (k * Math.PI) / 3 + t * 0.4 + p.ph;
        g.moveTo(x - Math.cos(a) * p.s, p.y - Math.sin(a) * p.s);
        g.lineTo(x + Math.cos(a) * p.s, p.y + Math.sin(a) * p.s);
      }
      g.stroke();
      g.strokeStyle = "rgba(255,255,255,0.97)";
      g.lineWidth = 1.3;
      g.stroke();
    });
  } else if (fx === "petals") {
    list.forEach((p) => {
      p.y += p.v * s * f;
      p.r += 0.035;
      if (p.y > H + 10) (p.y = -10), (p.x = rand(0, W));
      g.save();
      g.translate(p.x + Math.sin(t * 1.1 + p.ph) * 20, p.y);
      g.rotate(p.r);
      g.scale(1, 0.35 + 0.65 * Math.abs(Math.sin(t * 2 + p.ph)));
      g.fillStyle = tint;
      g.globalAlpha = 0.9;
      g.beginPath();
      g.moveTo(-p.s, 0);
      g.quadraticCurveTo(0, -p.s * 0.65, p.s, 0);
      g.quadraticCurveTo(0, p.s * 0.65, -p.s, 0);
      g.fill();
      g.strokeStyle = "rgba(255,255,255,0.75)";
      g.lineWidth = 1;
      g.stroke();
      g.restore();
    });
  } else if (fx === "embers") {
    g.lineCap = "round";
    list.forEach((p) => {
      p.y -= p.v * s * f;
      if (p.y < -14) (p.y = H + 10), (p.x = rand(0, W));
      const x = p.x + Math.sin(t * 1.6 + p.ph) * 7;
      const a = 0.6 + 0.4 * Math.sin(t * 6 + p.ph);
      const gg = 150 + Math.round(70 * Math.sin(t * 5 + p.ph));
      g.beginPath();
      g.moveTo(x, p.y);
      g.lineTo(x + Math.sin(t + p.ph) * 3, p.y + p.s);
      g.strokeStyle = `rgba(255,${gg - 40},40,${a * 0.3})`;
      g.lineWidth = 6;
      g.stroke();
      g.strokeStyle = `rgba(255,${gg + 30},120,${a})`;
      g.lineWidth = 2;
      g.stroke();
    });
  } else if (fx === "rain") {
    g.strokeStyle = "rgba(225,236,255,0.55)";
    g.lineWidth = 1.3;
    g.beginPath();
    list.forEach((p) => {
      p.y += p.v * s * f;
      p.x -= p.v * 0.25 * f;
      if (p.y > H) (p.y = -p.s), (p.x = rand(0, W * 1.2));
      g.moveTo(p.x, p.y);
      g.lineTo(p.x - p.s * 0.25, p.y + p.s);
    });
    g.stroke();
  } else if (fx === "streaks") {
    g.lineCap = "round";
    list.forEach((p) => {
      const a = t * p.v + p.ph;
      g.beginPath();
      g.ellipse(p.x, p.y, p.s, p.s * 0.55, a * 0.4, a, a + 1.7);
      g.globalAlpha = 0.5 * s;
      g.strokeStyle = tint;
      g.lineWidth = 3.4;
      g.stroke();
      g.globalAlpha = 0.6 * s;
      g.strokeStyle = "rgba(255,255,255,0.9)";
      g.lineWidth = 1.1;
      g.stroke();
    });
    g.globalAlpha = 1;
  } else if (fx === "shimmer") {
    const k = ((t * 0.38) % 1.6) - 0.3;
    const gr = g.createLinearGradient(W * k - W * 0.35, 0, W * k + W * 0.35, H);
    gr.addColorStop(0, "rgba(255,255,255,0)");
    gr.addColorStop(0.35, `hsla(${(t * 60) % 360},95%,70%,${0.45 * s})`);
    gr.addColorStop(0.5, `rgba(255,255,255,${0.55 * s})`);
    gr.addColorStop(0.65, `hsla(${(t * 60 + 120) % 360},95%,70%,${0.45 * s})`);
    gr.addColorStop(1, "rgba(255,255,255,0)");
    g.globalCompositeOperation = "screen";
    g.fillStyle = gr;
    g.fillRect(0, 0, W, H);
    g.globalCompositeOperation = "overlay";
    g.fillStyle = `hsla(${(t * 30) % 360},80%,55%,${0.16 * s})`;
    g.fillRect(0, 0, W, H);
    g.globalCompositeOperation = "source-over";
  } else if (fx === "mist") {
    for (let i = 0; i < 4; i++) {
      const y = H * (0.25 + i * 0.2) + Math.sin(t * 0.35 + i) * 14;
      const gr = g.createLinearGradient(0, y - 46, 0, y + 46);
      gr.addColorStop(0, "rgba(255,255,255,0)");
      gr.addColorStop(0.5, `rgba(255,255,255,${0.32 * s})`);
      gr.addColorStop(1, "rgba(255,255,255,0)");
      g.fillStyle = gr;
      g.fillRect(-W * 0.3 + ((t * 22 * (i + 1)) % (W * 0.6)), y - 46, W * 1.2, 92);
    }
  } else if (fx === "flicker") {
    const v = 0.14 + 0.12 * (Math.sin(t * 7.3) * 0.5 + Math.sin(t * 13.1) * 0.3 + Math.sin(t * 3.7) * 0.2);
    g.globalCompositeOperation = "soft-light";
    g.fillStyle = `rgba(255,160,60,${Math.max(0, v) * s * 3})`;
    g.fillRect(0, 0, W, H);
    g.globalCompositeOperation = "lighter";
    g.fillStyle = `rgba(255,150,60,${Math.max(0, v) * s * 0.35})`;
    g.fillRect(0, 0, W, H);
    g.globalCompositeOperation = "source-over";
  } else if (fx === "aura") {
    const a = (0.22 + 0.14 * Math.sin(t * 1.3)) * s;
    const gr = g.createRadialGradient(W / 2, H / 2, Math.max(1, Math.min(W, H) * 0.22), W / 2, H / 2, Math.max(W, H) * 0.72);
    gr.addColorStop(0, "rgba(255,220,150,0)");
    gr.addColorStop(1, `rgba(255,205,120,${Math.min(0.85, a * 2.6)})`);
    g.globalCompositeOperation = "lighter";
    g.fillStyle = gr;
    g.fillRect(0, 0, W, H);
    g.globalCompositeOperation = "source-over";
  } else if (fx === "ripples") {
    g.lineCap = "round";
    for (let i = 0; i < 12; i++) {
      const y = H * 0.56 + i * H * 0.037 + Math.sin(t * 1.4 + i) * 3;
      const x0 = ((t * 34 + i * 57) % (W * 1.1)) - W * 0.1;
      g.strokeStyle = `rgba(255,255,255,${(0.28 + 0.2 * Math.sin(t * 2 + i)) * s})`;
      g.lineWidth = 1.6;
      g.beginPath();
      g.moveTo(x0, y);
      g.quadraticCurveTo(x0 + W * 0.12, y - 3, x0 + W * 0.25, y);
      g.stroke();
    }
  }
}

export function createLiving(c, painting, { strength: base = 1, small = false, width, height, effects, delay = 3000 } = {}) {
  const fx = (effects || painting.effects || []).filter((e) => EFFECTS.includes(e));
  const g = c.getContext("2d");
  const img = new Image();
  img.crossOrigin = "anonymous";
  img.src = imageSrc(small ? painting.thumb_url || painting.image_url : painting.image_url);
  const fixed = !!width;
  const dpr = fixed ? 1 : Math.min(1.5, window.devicePixelRatio || 1);
  const tint = (painting.palette || []).find((h) => h && h !== "#ffffff") || "#F6A5C8";
  let W = 0, H = 0, raf, pts = {}, mx = 0, my = 0, drawn = false, last = 0, since = performance.now(), held = false, level = 0, strength = 0;
  const size = () => {
    if (fixed) (W = width), (H = height);
    else {
      const r = c.getBoundingClientRect();
      W = r.width;
      H = r.height;
    }
    c.width = Math.max(1, W * dpr);
    c.height = Math.max(1, H * dpr);
    g.setTransform(dpr, 0, 0, dpr, 0, 0);
    const k = Math.max(0.5, Math.min(1.6, (W * H) / (520 * 520)));
    pts = Object.fromEntries(fx.filter((e) => SPAWN[e]).map((e) => [e, Array.from({ length: Math.round(COUNT[e] * k) }, () => SPAWN[e](W, H))]));
  };
  const ro = fixed ? null : new ResizeObserver(size);
  if (ro) ro.observe(c);
  else size();
  const move = (e) => {
    mx = e.clientX / window.innerWidth - 0.5;
    my = e.clientY / window.innerHeight - 0.5;
  };
  if (!fixed) window.addEventListener("pointermove", move);
  const frame = (now) => {
    const t = now / 1000;
    const dt = Math.min(0.05, last ? t - last : 0.016);
    last = t;
    const want = held ? 0 : Math.min(1, Math.max(0, (now - since - delay) / 1500));
    level += (want - level) * Math.min(1, dt * (held ? 8 : 2.5));
    if (want === 0 && level < 0.01) level = 0;
    strength = base * level;
    if (img.complete && img.naturalWidth && W) {
      const u = W / 500;
      g.clearRect(0, 0, W, H);
      const disp = level > 0 && (fx.includes("ripples") || fx.includes("sway"));
      const par = level > 0 && fx.includes("parallax");
      const px = par ? (mx * 0.6 + Math.sin(t * 0.45) * 0.5) * level : 0;
      const py = par ? (my * 0.6 + Math.cos(t * 0.37) * 0.4) * level : 0;
      const k = par ? 1 + 0.1 * level : 1;
      const clampP = (v) => Math.max(-1, Math.min(1, v));
      g.save();
      if (par) g.translate(-clampP(px) * W * 0.04 - (W * (k - 1)) / 2, -clampP(py) * H * 0.04 - (H * (k - 1)) / 2), g.scale(k, k);
      g.drawImage(img, 0, 0, W, H);
      if (disp) {
        // displacement stays inside a 5% margin and fades out towards it, so the outline never bends
        const mx = W * 0.05;
        const my = H * 0.05;
        const fade = H * 0.06;
        const sh = img.naturalHeight / H;
        const strip = 3;
        g.beginPath();
        g.rect(mx, my, W - mx * 2, H - my * 2);
        g.clip();
        for (let y = my; y < H - my; y += strip) {
          let dx = 0;
          if (fx.includes("sway")) dx += Math.sin(t * 1.1 + y * 0.012) * 5 * u * (1 - y / H) * strength;
          if (fx.includes("ripples") && y > H * 0.5) dx += Math.sin(y * 0.11 / u + t * 2.4) * 4 * u * strength * Math.min(1, (y - H * 0.5) / (H * 0.12));
          dx *= Math.max(0, Math.min(1, (y - my) / fade, (H - my - y) / fade));
          if (Math.abs(dx) < 0.05) continue;
          g.drawImage(img, 0, y * sh, img.naturalWidth, strip * sh, dx, y, W, strip + 0.5);
        }
      }
      g.restore();
      if (level > 0) fx.forEach((e) => draw(g, e, pts[e], W, H, t, strength, tint, dt));
      drawn = true;
    }
    raf = requestAnimationFrame(frame);
  };
  raf = requestAnimationFrame(frame);
  return {
    drawn: () => drawn,
    still: () => level === 0,
    restart: () => (since = performance.now()),
    hold: (on) => (held = on),
    stop: () => {
      cancelAnimationFrame(raf);
      ro?.disconnect();
      window.removeEventListener("pointermove", move);
    },
  };
}
